<template>
  <div class="p-right-25-important" v-if="type === 'sms'">
    <div v-if="hasSmsLogs">
      <!-- SMS Logs -->
      <div v-if="Object.keys(mergedLogs).length">
        <sms-log-table
          :sms-logs="mergedLogs"
          :date-time-obj="dateTimeObj"
          :twilio-account-number="twilioAccountNumber"
          title="Booking"
        ></sms-log-table>
      </div>
    </div>

    <div v-else>
      <div class="inquiry-no-result">
        <br />
        <h3 class="font-bold"><span class="fa fa-ban"></span> There are no sms history</h3>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import SmsLogTable from "@/modules/Booking/components/BookingViewTabs/Communication/SmsLogTable.vue";
import { getSingleTabData } from "@/modules/Booking/api/BookingViewTabs";
import { EventBus } from "@/events/event-bus";

export default {
  name: "SmsTab",
  components: { SmsLogTable },

  props: {
    value: {
      type: Object,
    },
    itemType: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    bookingId: {
      type: Number,
    },
    credentials: {
      type: Object,
      default() {
        return {};
      },
    },
    complaintId: {
      default() {
        return "";
      },
    },
    inquiryId: {
      default() {
        return "";
      },
    },
    bookingIds: {
      type: Array,
      default() {
        return [];
      },
    },
    originalInquiryIds: {
      type: Array,
      default() {
        return [];
      },
    },
    invoiceIds: {
      type: Array,
      default() {
        return [];
      },
    },
    mergedInvoiceId: {
      default() {
        return "";
      },
    },
    customerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      type: "sms",
      bookingSmsLogs: [],
      invoiceSmsLogs: [],
      estimateSmsLogs: [],
      inquirySmsLogs: [],
      complaintSmsLogs: [],
      dateTimeObj: null,
      twilioAccountNumber: null,
      mergedLogs: {},
    };
  },
  computed: {
    hasSmsLogs() {
      return Object.keys(this.mergedLogs).length;
    },
  },
  methods: {
    groupSmsLogs(logs) {
      let groupedLogs = {};
      if (this.dateTimeObj) {
        const dateFormat = this.convertToMomentFormat(
          this.dateTimeObj.date_format
        );
        const timeFormat = this.dateTimeObj.time_format;
        // Group call logs by date
        logs.forEach((log) => {
          const dateKey = moment(log.send_time)
            .tz(this.dateTimeObj.time_zone)
            .format(dateFormat);
          if (!groupedLogs[dateKey]) {
            groupedLogs[dateKey] = [];
          }
          log.time_formated = moment(log.send_time)
            .tz(this.dateTimeObj.time_zone)
            .format(timeFormat);
          groupedLogs[dateKey].push(log);
        });
      }
      return groupedLogs;
    },
    convertToMomentFormat(format) {
      const mapping = {
        "EEEE, d MMMM y": "dddd, D MMMM YYYY",
        "d MMMM y": "D MMMM YYYY",
        "d MMM y": "D MMM YYYY",
        "dd/mm/yyyy": "DD/MM/YYYY",
        // Add any additional mappings as needed
      };
      return mapping[format] || "Format not recognized";
    },
    fillAllTab() {
      // Create an empty object to store the merged email logs
      let mergedEmailLogs = {};

      // Merge the email logs from different objects
      if (this.bookingSmsLogs)
        Object.assign(mergedEmailLogs, this.bookingSmsLogs);
      if (this.invoiceSmsLogs)
        Object.assign(mergedEmailLogs, this.invoiceSmsLogs);
      if (this.estimateSmsLogs)
        Object.assign(mergedEmailLogs, this.estimateSmsLogs);
      if (this.inquirySmsLogs)
        Object.assign(mergedEmailLogs, this.inquirySmsLogs);
      if (this.complaintSmsLogs)
        Object.assign(mergedEmailLogs, this.complaintSmsLogs);

      this.$emit("input", mergedEmailLogs);
    },
    getSmsTabData() {
      let params = {
        type: "sms",
        booking_id: this.bookingId,
        customer_id: this.customerId,
        complaint_id: this.complaintId,
        inquiry_id: this.inquiryId,
        booking_ids: this.bookingIds,
        mergedInvoiceId: this.mergedInvoiceId,
        original_inquiry_ids: this.originalInquiryIds,
        invoice_ids: this.invoiceIds,
        fromVuejs: true,
      };
      if (this.itemType === "estimate") params.estimate_ids = [this.itemId];
      getSingleTabData(params).then((response) => {
        this.dateTimeObj = response.data.dateTimeObj;
        this.bookingSmsLogs = response.data.bookingSmsLogs || [];
        this.invoiceSmsLogs = response.data.invoiceSmsLogs || [];
        this.estimateSmsLogs = response.data.estimateSmsLogs || [];
        this.inquirySmsLogs = response.data.inquirySmsLogs || [];
        this.complaintSmsLogs = response.data.complaintSmsLogs || [];
        this.twilioAccountNumber = response.data.twilioAccountNumber;

        this.mergedLogs = this.groupSmsLogs([
          ...this.bookingSmsLogs,
          ...this.invoiceSmsLogs,
          ...this.estimateSmsLogs,
          ...this.inquirySmsLogs,
          ...this.complaintSmsLogs,
        ]);
        this.$emit("input", this.mergedLogs);
        EventBus.$emit(
          "setTwilioAccountNumber",
          response.data.twilioAccountNumber
        );
      });
    },
    initializeEventListeners() {
      EventBus.$on("smsSentSuccessfully", (data) => {
        this.getSmsTabData();
      });
    },
  },
  mounted() {
    this.getSmsTabData();
    EventBus.$on("refetchSmsData", () => {
      this.getSmsTabData();
    });
    this.initializeEventListeners();
  },
};
</script>

<style scoped>
.p-right-25-important {
  padding-right: 25px !important;
}
</style>
